import React, { FC, useEffect } from "react";
import "./style.scss";
import { Box, Grid, Typography } from "@material-ui/core";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import ChargeView from "./charge";
import InternetView from "./internet";
import BillView from "./bill";
import GiftCardView from "./gift-card";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from "../../redux";
import { FetchLoginAction } from "../../redux/login/actions";
import { useLocation } from "react-router";
import Loader from "../../components/loader";
import TopTabPanel from "../../components/tabPanel/tabPanel"
import {useParams} from "react-router-dom";
import { SetPaymentType } from "../../redux/chargePackage/actions";


interface TabPanelProps {
  children?: React.ReactNode;
  index: any;
  value: any;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        // @ts-ignore
        <Box p={2} >
          {/* @ts-ignore */}
          <Box>{children}</Box>
        </Box>
      )}
    </div>
  );
}


const Main: FC = () => {
  const dispatch = useDispatch();
  const param = useLocation();
  const {
    authorization: { access_token, loading },
    payment: { type },
  } = useSelector(({ authorization, payment }: ApplicationState) => ({
    authorization,
    payment,
  }));
  const classes = useStyles();

  useEffect(() => {
    let params = new URLSearchParams(param.search);
    let company_url_name = params.get("company");
    if (company_url_name)
      dispatch(FetchLoginAction({ company_name: company_url_name }));
    else
      dispatch(FetchLoginAction({ company_name: "eniac" }));

    const initTabIndex = params.get("tab");
    initTabIndex && dispatch(SetPaymentType(parseInt(initTabIndex)));
  }, []);
console.log(param)
  return (
    <div className="main">
      {!access_token ? (
        <div className={classes.warning}>
          <Typography className={classes.warningText}>
            خطا در دریافت اعتبار سنجی
          </Typography>
        </div>
      ) : (
        ""
      )}
      <div className={"root pt-3"}>
        <TopTabPanel />
        <Loader loading={loading}>
          <Grid container justifyContent="center">
            <Grid item md={6} lg={5}>
              <TabPanel value={type} index={0}>
                <InternetView />
              </TabPanel>
              <TabPanel value={type} index={1}>
                <ChargeView />
              </TabPanel>
              <TabPanel value={type} index={3}>
                <BillView />
              </TabPanel>
            </Grid>
          </Grid>
          <Grid container justifyContent="center">
            <Grid item md={10}>
              <TabPanel value={type} index={2}>
                <GiftCardView />
              </TabPanel>
            </Grid>
          </Grid>
        </Loader>
      </div>
    </div >
  );
};

export default Main;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      position: "absolute",
      width: 400,
      backgroundColor: theme.palette.background.paper,
      border: "2px solid #000",
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
    },
    responsiveBreak: {
      [theme.breakpoints.only("md")]: {},
    },
    warning: {
      width: "100%",
      height: "calc(100vh - 70px)",
      margin: "0 auto",
      backgroundColor: "#0000009c",
      zIndex: 9999,
      position: "absolute",
    },
    warningText: {
      color: "#ffffff",
      textAlign: "center",
      fontSize: "37px",
      zIndex: 99999,
      opacity: "1!important",
      marginTop: "25vh",
    },
  })
);
